import moment from "moment";
import type { Notification } from "../../types";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Button } from "@/components/ui/button";

dayjs.extend(relativeTime);

interface LeadMemberAssignProps {
  notification: Notification;
  updateNotificationStatus?: (params: {
    notification?: any;
    redirect?: boolean;
    otherSwitch?: boolean;
  }) => void;
}

export const LeadMemberAssign = ({
  notification,
  updateNotificationStatus,
}: LeadMemberAssignProps) => {
  const handleMarkAsRead = () => {
    if (updateNotificationStatus) {
      updateNotificationStatus({
        notification: notification,
      });
    }
  };

  return (
    <div className="bg-primary/10 p-2 rounded-md w-full relative">
      <h2 className="text-sm font-medium">Lead Member Assign</h2>
      <p className="text-xs text-muted-foreground mt-1">
        {notification.notification_message}
      </p>
      <time
        className="text-xs absolute top-2 right-2"
        dateTime={notification.notification_time}
      >
        {dayjs(notification.notification_time).fromNow()}
      </time>
      <div className="mt-2">
        <Button size="sm" asChild>
          <a href={`/leads/detail/${notification.lead_id}`}>View Lead</a>
        </Button>
        {!notification.read_status && (
          <Button
            size="sm"
            variant="outline"
            className="ml-2"
            onClick={handleMarkAsRead}
          >
            Mark as read
          </Button>
        )}
      </div>
    </div>
  );
};
